import ReservationsTable from "../Pages/Reservations/Reservations_Table";
import ViewReservations from "../Pages/Reservations/View_Reservations";
import AddBuchungen from "../Pages/Reservations/AddBuchungen";

import { Navigate } from "react-router";

const role=localStorage.getItem("role")
export const ReservationsRoutes = [
  {
    path: '/Reservations',
    element: <ReservationsTable/>
  },
  {
    path: '/Reservations/ViewReservations/:id',
    element: <ViewReservations />
  },
  {
    path: '/Reservations/AddBuchungen',
    element: role !== 'manager' ? <Navigate to="/" replace /> : <AddBuchungen />
  },
];